export default "__VITE_ASSET__VMCHoy83__"